import Button from '@/features/shared/Button';
import React from 'react';
import { useVisibility } from '@/hooks/useVisibility';

const MultiButtonContent = ({ links = [], theme, className }: any) => {
  const { getLinkVisibility } = useVisibility();

  return (
    <div className={className}>
      {links.map((link: LinkType, idx: number) => {
        const { buttonStyle = '', ...props } = link || {};
        const buttonProps = {
          outlined: /secondary/.test(buttonStyle),
          variant: /highlighted/.test(buttonStyle) ? 'link' : 'button',
          theme,
          link: props,
        };

        const isVisible = getLinkVisibility(props);

        if (!isVisible) return null;

        return (
          <div key={`link_${idx}`} className="buttonWrapper">
            <Button {...buttonProps} />
          </div>
        );
      })}
    </div>
  );
};

export default MultiButtonContent;
